import { Ability } from '@casl/ability'
import { initialAbility } from './config'

const userRoutes = JSON.parse(localStorage.getItem('userRoutes'))
const userData = JSON.parse(localStorage.getItem('userData'))
const existingAbility = userData ? userRoutes : null

export default new Ability(existingAbility || initialAbility)
